import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { Row, Column, FormInput } from 'Shared/components';
import { CoveredPartyPayloadType } from '@clearcover/core-app-types';
import styles from './styles.module.css';
import { DriverMilitaryOptionsType } from './DriverForm';
import { militaryStatusOptions } from './utils';

type DriverMilitaryInfoProps = {
  options: DriverMilitaryOptionsType;
};

export const DriverMilitaryInfo: FC<DriverMilitaryInfoProps> = ({
  options,
}) => {
  const { handleBlur, setFieldValue, values } = useFormikContext<
    CoveredPartyPayloadType
  >();

  return (
    <div className={styles.section} data-testid="driver-section-military-info">
      <h1>Military Info</h1>
      <Row>
        <Column className={styles.driverInfoCol}>
          <FormInput
            variant="selectAutocomplete"
            name="military.militaryStatus"
            data-testid="military-status"
            onChange={(value: string) => {
              setFieldValue('military.militaryStatus', value);
              if (value === militaryStatusOptions.no_military_history) {
                setFieldValue('military.rank', '');
                setFieldValue('military.isDeployed', 'No');
              }
              if (value === militaryStatusOptions.discharged_or_retired) {
                setFieldValue('military.isDeployed', 'No');
              }
            }}
            onBlur={handleBlur}
            value={values.military.militaryStatus}
            label="Military Status"
            options={options?.militaryStatus ?? {}}
          />
        </Column>
        <Column className={styles.driverInfoCol}>
          <FormInput
            variant="selectAutocomplete"
            name="military.rank"
            data-testid="military-rank"
            onChange={(value: string) => setFieldValue('military.rank', value)}
            onBlur={handleBlur}
            value={values.military.rank}
            disabled={
              values.military.militaryStatus ===
              militaryStatusOptions.no_military_history
            }
            label="Military Rank"
            options={options?.militaryRank ?? {}}
          />
        </Column>
        <Column className={styles.driverInfoCol}>
          <FormInput
            variant="selectAutocomplete"
            name="military.isDeployed"
            data-testid="military-is-deployed"
            onChange={(value: string) =>
              setFieldValue('military.isDeployed', value)
            }
            onBlur={handleBlur}
            value={values.military.isDeployed}
            disabled={
              values.military.militaryStatus ===
                militaryStatusOptions.no_military_history ||
              values.military.militaryStatus ===
                militaryStatusOptions.discharged_or_retired
            }
            label="Currently deployed overseas?"
            tooltip="Includes stations in Hawaii and Alaska."
            options={{ true: 'Yes', false: 'No' }}
          />
        </Column>
      </Row>

      <Row>
        {options.allowDependentDiscount && (
          <>
            <Column className={styles.driverInfoCol}>
              <FormInput
                variant="selectAutocomplete"
                name="military.isCertifiedMilitaryDependent"
                data-testid="military-is-dependent"
                onChange={(value: string) =>
                  setFieldValue('military.isCertifiedMilitaryDependent', value)
                }
                onBlur={handleBlur}
                value={values.military.isCertifiedMilitaryDependent}
                disabled={!options?.allowDependentDiscount}
                label="Dependent of deployed active military?"
                options={{ true: 'Yes', false: 'No' }}
              />
            </Column>
            <Column />
            <Column />
          </>
        )}
      </Row>
    </div>
  );
};
